import React, {Component} from 'react';
import {connect} from 'react-redux';
import UploadList from 'components/views/upload-list';
import UploadListForm from 'components/views/upload-list-form';
import EmptyUploadList from 'components/views/empty-list';
import store from 'store';
import {addUploadingAssets} from 'actions/asset-actions';
import {clearUploads, setUploadData, deleteKeyword} from 'actions/upload-actions';
import {hideSpinner, spinnerHasClass} from 'utils/spinner';
import scrollUtils from 'utils/scroll-utils';
import isLocalStorageSupported from 'utils/local-storage';
import FileUpload from 'utils/file-upload';
import _ from 'lodash';

class UploadListContainer extends Component {

    componentDidMount() {
        scrollUtils.setLastWindowPosition(0);
        if (!spinnerHasClass('xhr-on')) {
            hideSpinner();
        }


        const privacy = isLocalStorageSupported() && localStorage.getItem('privacy') ? localStorage.getItem('privacy') :
            this.props.uploadData.privacy;
        const selectedOrganization = this.props.organizations[0].organizationId;
        const o = {privacy, selectedOrganization};
        store.dispatch(setUploadData(o));
    }

    titleChanged(e) {
        store.dispatch(setUploadData({
            title: e.target.value
        }));
    }

    descriptionChanged(e) {
        store.dispatch(setUploadData({
            caption: e.target.value
        }));
    }

    privacyChanged(e) {
        const o = {
            privacy: e.target.value
        };
        store.dispatch(setUploadData(o));
        if (isLocalStorageSupported()) {
            localStorage.setItem('privacy', o.privacy);
        }
    }

    keywordChanged(e) {
        store.dispatch(setUploadData({
            keywordsStr: e.target.value
        }));
    }

    organizationChanged(value) {
      store.dispatch(setUploadData({
        selectedOrganization: value
      }));
    }

    deleteKeyword(keyword) {
        store.dispatch(deleteKeyword(keyword));
    }

    attributionChanged(e) {
        // if value is empty, set attributionMode to NONE
        if (e.target.value === '') {
            this.attributionModeChanged(null, false);
        }

        store.dispatch(setUploadData({
            attribution: e.target.value
        }));
    }

    attributionModeChanged(e, mode) {
        const attributionMode = mode ? 'SHOW_IN_VIDEO' : 'NONE';
        store.dispatch(setUploadData({ attributionMode }));
    }

    uploadItems() {
        document.activeElement.blur();
        let files = [...this.props.files];
        const {title, caption, privacy, keywords, attribution, attributionMode, selectedOrganization} = this.props.uploadData;
        files = files.map(file => {
            const o = {
                caption,
                privacy,
                fileSize: file.file.size,
                title: title || file.title,
                keywords,
                attribution,
                attributionMode,
                selectedOrganization
            };
            return Object.assign({}, file, o)
        });
        if (!window.uploads) {
            window.uploads = {};
        }
        const user = _.pick(store.getState().userProfile, ['username', 'firstName', 'lastName']);
        files.forEach(file => {
            const params = Object.assign({}, file, {ownerUserDbId: this.props.userId});
            const fileUpload = new FileUpload(params, user);
            window.uploads[file.tempUUID] = fileUpload;
            fileUpload.start();
        });
        store.dispatch(addUploadingAssets(files));
        store.dispatch(clearUploads());
        this.props.router.push('/');
    }

    render() {
        const changeHandlers = {
            title: this.titleChanged.bind(this),
            privacy: this.privacyChanged.bind(this),
            description: this.descriptionChanged.bind(this),
            keywords: this.keywordChanged.bind(this),
            deleteKeyword: this.deleteKeyword.bind(this),
            attribution: this.attributionChanged.bind(this),
            organization: this.organizationChanged.bind(this),
            attributionMode: this.attributionModeChanged.bind(this)
        };

        let uploadList;
        if (this.props.files && this.props.files.length) {
            uploadList = <div>
                <UploadListForm changeHandlers={changeHandlers}
                    title={this.props.uploadData.title}
                    caption={this.props.uploadData.caption}
                    privacy={this.props.uploadData.privacy}
                    keywordsStr={this.props.uploadData.keywordsStr}
                    keywords={this.props.uploadData.keywords}
                    organizations={this.props.organizations}
                    selectedOrganization={this.props.uploadData.selectedOrganization}
                    attribution={this.props.uploadData.attribution}
                    attributionMode={this.props.uploadData.attributionMode}
                />
                <UploadList onTouchTap={this.uploadItems.bind(this)} assets={this.props.files} />
            </div>;
        } else {
            uploadList = <EmptyUploadList title="In Progress" icon="note" hasBottomArrow={true}/>
        }


        return uploadList;
    }
}

const mapStateToProps = function (store) {
    return {
        files: store.currentUpload.files,
        programmers: store.userProfile.programmers.map(p => p.id),
        userId: store.userProfile.employeeId,
        organizations: store.userProfile.organizations,
        uploadData: store.currentUpload.uploadData
    };
};

export default connect(mapStateToProps)(UploadListContainer);
